import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../auth/AuthContext";
import "../assets/css/Steps.css";

const dropdownMap = {
  SubAdmins: ["/add-subadmin", "/subadmin-list"],
  Brands: ["/brands-list", "/add-brand"],
  Products: ["/products-list", "/add-product"],
  Subscribers: ["/subscribers-list"],
  Contact: ["/contact-list"],
  Offers: ["/add-offer", "/offer-list"],
  Banners: ["/add-banner", "/banner-list"],
  "Focus Areas": ["/focus-add", "/focus-list"],
  Testimonial: ["/add-testimonial", "/testimonial-list"],
};

function Nav({ isCollapsed, setIsCollapsed }) {
  const { profile } = useContext(AuthContext);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();
  const handleToggle = () => {
    setIsCollapsed(!isCollapsed);
  };
  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    let found = false;
    Object.entries(dropdownMap).forEach(([dropdown, paths]) => {
      if (paths.some((p) => location.pathname === p)) {
        setActiveDropdown(dropdown);
        found = true;
      }
    });
    if (!found) {
      setActiveDropdown(null);
    }
  }, [location.pathname]);

  const toggleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  return (
    <div className={`navbars ${isCollapsed ? "collapsed" : ""}`}>
      <div className="slid-nav" onClick={handleToggle}>
        <i className="fa-solid fa-list"></i>
      </div>
      <ul className="navlist">
        <li className={isActive("/") ? "" : ""}>
          <Link to="/">
            <i className="fa-solid fa-house"></i>
            {!isCollapsed && "Home"}
          </Link>
        </li>
        {/* Subadmin Dropdown */}
        {profile?.id === 1 && (
          <li
            className={activeDropdown === "Subadmins" ? "active" : ""}
            onClick={() => toggleDropdown("Subadmins")}
          >
            <i className="fa-solid fa-circle-user"></i>
            {!isCollapsed && "Subadmins"}

            {activeDropdown === "Subadmins" && !isCollapsed && (
              <ul className="menu">
                <li className={isActive("/add-subadmin") ? "active" : ""}>
                  <Link to="/add-subadmin">Add Subadmin</Link>
                </li>
                <li className={isActive("/subadmin-list") ? "active" : ""}>
                  <Link to="/subadmin-list">Subadmin List</Link>
                </li>
              </ul>
            )}
          </li>
        )}
        {/* Brands Dropdown */}
        <li
          className={activeDropdown === "Brands" ? "active" : ""}
          onClick={() => toggleDropdown("Brands")}
        >
          <i className="fas fa-handshake" aria-hidden="true"></i>
          {!isCollapsed && "Brands"}
          {activeDropdown === "Brands" && !isCollapsed && (
            <ul className="menu">
              <li className={isActive("/add-brand") ? "active" : ""}>
                <Link to="/add-brand">Add Brand</Link>
              </li>
              <li className={isActive("/brands-list") ? "active" : ""}>
                <Link to="/brands-list">Brands List</Link>
              </li>
            </ul>
          )}
        </li>
        {/* Products Dropdown */}
        <li
          className={activeDropdown === "Products" ? "active" : ""}
          onClick={() => toggleDropdown("Products")}
        >
          <i className="fa fa-cart-plus" aria-hidden="true"></i>
          {!isCollapsed && "Products"}
          {activeDropdown === "Products" && !isCollapsed && (
            <ul className="menu">
              <li className={isActive("/add-product") ? "active" : ""}>
                <Link to="/add-product">Add Product</Link>
              </li>
              <li className={isActive("/products-list") ? "active" : ""}>
                <Link to="/products-list">Products List</Link>
              </li>
            </ul>
          )}
        </li>
        {/* Subscribers Dropdown */}
        <li
          className={activeDropdown === "Subscribers" ? "active" : ""}
          onClick={() => toggleDropdown("Subscribers")}
        >
          <i className="fa-solid fa-bell"></i>
          {!isCollapsed && "Subscribers"}
          {activeDropdown === "Subscribers" && !isCollapsed && (
            <ul className="menu">
              <li className={isActive("/subscribers-list") ? "active" : ""}>
                <Link to="/subscribers-list">Subscribers List</Link>
              </li>
            </ul>
          )}
        </li>
        {/* Contact Dropdown */}
        <li
          className={activeDropdown === "Contact" ? "active" : ""}
          onClick={() => toggleDropdown("Contact")}
        >
          <i className="fa-solid fa-paper-plane"></i>
          {!isCollapsed && "Contact"}
          {activeDropdown === "Contact" && !isCollapsed && (
            <ul className="menu">
              <li className={isActive("/contact-list") ? "active" : ""}>
                <Link to="/contact-list">Contact List</Link>
              </li>
            </ul>
          )}
        </li>
        {/* Offers Dropdown */}
        <li
          className={activeDropdown === "Offers" ? "active" : ""}
          onClick={() => toggleDropdown("Offers")}
        >
          <i className="fa fa-commenting" aria-hidden="true"></i>
          {!isCollapsed && "Offers"}
          {activeDropdown === "Offers" && !isCollapsed && (
            <ul className="menu">
              <li className={isActive("/add-offer") ? "active" : ""}>
                <Link to="/add-offer">Add Offer</Link>
              </li>
              <li className={isActive("/offer-list") ? "active" : ""}>
                <Link to="/offer-list">Offer List</Link>
              </li>
            </ul>
          )}
        </li>
        {/* Banners Dropdown */}
        <li
          className={activeDropdown === "Banners" ? "active" : ""}
          onClick={() => toggleDropdown("Banners")}
        >
          <i className="fa fa-image"></i>
          {!isCollapsed && "Banners"}
          {activeDropdown === "Banners" && !isCollapsed && (
            <ul className="menu">
              <li className={isActive("/add-banner") ? "active" : ""}>
                <Link to="/add-banner">Add Banner</Link>
              </li>
              <li className={isActive("/banner-list") ? "active" : ""}>
                <Link to="/banner-list">Banners List</Link>
              </li>
            </ul>
          )}
        </li>
        {/* Focus Areas Dropdown */}
        <li
          className={activeDropdown === "Focus Areas" ? "active" : ""}
          onClick={() => toggleDropdown("Focus Areas")}
        >
          <i className="fa-solid fa-bullseye"></i>
          {!isCollapsed && " Focus Areas"}
          {activeDropdown === "Focus Areas" && !isCollapsed && (
            <ul className="menu">
              <li className={isActive("/focus-add") ? "active" : ""}>
                <Link to="/focus-add">Focus Add</Link>
              </li>
              <li className={isActive("/focus-list") ? "active" : ""}>
                <Link to="/focus-list">Focus List</Link>
              </li>
            </ul>
          )}
        </li>
        {/* Testimonial Dropdown */}
        <li
          className={activeDropdown === "Testimonial" ? "active" : ""}
          onClick={() => toggleDropdown("Testimonial")}
        >
          <i className="fa-solid fa-fire-flame-curved"></i>
          {!isCollapsed && " Testimonial"}
          {activeDropdown === "Testimonial" && !isCollapsed && (
            <ul className="menu">
              <li className={isActive("/add-testimonial") ? "active" : ""}>
                <Link to="/add-testimonial">Add Testimonial</Link>
              </li>
              <li className={isActive("/testimonial-list") ? "active" : ""}>
                <Link to="/testimonial-list">Testimonial List</Link>
              </li>
            </ul>
          )}
        </li>
      </ul>
    </div >
  );
}

export default Nav;
